/**
 * feat-66 · Validación del archivo del logo en el cliente (solo UX). El back decide por los *magic
 * bytes*, las dimensiones y el contenido del SVG (`apps/api/src/modules/files/domain/imagen-logo.ts`).
 */
export const LOGO_MAX_BYTES = 2 * 1024 * 1024;
export const LOGO_ACCEPT = 'image/png,image/jpeg,image/svg+xml,.png,.jpg,.jpeg,.svg';

const TIPOS = new Set(['image/png', 'image/jpeg', 'image/svg+xml']);
const EXTENSION = /\.(png|jpe?g|svg)$/i;

export const MENSAJE_LOGO_FORMATO = 'El logo debe ser una imagen PNG, JPG o SVG.';
export const MENSAJE_LOGO_TAMANO = 'El logo no puede superar 2 MB.';

export function validarArchivoLogo(archivo: File): string | null {
  const tipoValido = archivo.type ? TIPOS.has(archivo.type) : EXTENSION.test(archivo.name);
  if (!tipoValido) return MENSAJE_LOGO_FORMATO;
  if (archivo.size > LOGO_MAX_BYTES) return MENSAJE_LOGO_TAMANO;
  return null;
}

export function iniciales(nombre: string): string {
  const palabras = nombre.trim().split(/\s+/).filter(Boolean);
  return palabras
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join('');
}
